export function toScreamingSnake(value: string): string {
  return (
    value
      .normalize('NFD')
      .replaceAll(/[̀-ͯ]/g, '')
      .toUpperCase()
      .replaceAll(/[^A-Z0-9]+/g, '_')
      // Runs are already collapsed by the previous replace, so a single
      // leading/trailing underscore is all that can occur here.
      .replaceAll(/(?:^_)|(?:_$)/g, '')
      .replaceAll(/_{2,}/g, '_')
  );
}
